import React, { useEffect, useRef, useState } from "react";
import BasicLayout from "../layauots/BasicLayout";
import { Card } from "react-bootstrap";
import MDBox from "../controls/MDBox";
import MDTypography from "../controls/MDTypography";
import ManualAyuda from "../controls/ManualAyuda";
import bgImage from "../../assets/images/bg-sign-up-cover.jpeg";
import { Alert, AlertTitle, Checkbox } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Save2Fill } from "react-bootstrap-icons";
import MDButton from "../controls/MDButton";
import itemsMenu from "../Utils/itemsMenu";
import MDProgress from "../controls/MDProgress";
import { ExitToApp } from "@mui/icons-material";
import { postData } from "../Utils/Http/api";
import { getData } from "../Utils/Http/api";
const Permisos = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [mnuauditoria, setMnuAuditoria] = useState(false);
  
    const [moduloBI, setModuloBI] =
    useState(false);

 const [mnusujeto, setMnuSujeto] = useState(false);
 const [sujeto, setSujeto] = useState(false);
 const [importarArchivo, setImportarArchivo] = useState(false);
 const [tipoContacto, setTipoContacto] = useState(false);
 const [tipoIdentificacion, setTipoIdentificacion] = useState(false);
 const [origen, setOrigen] = useState(false);
 const [prioridadContacto, setPrioridadContacto] = useState(false);
 const [mensajes, setMensajes] = useState(false);
 const [motivoCualitativo, setMotivoCualitativo] = useState(false);

 const [mnuOrganismo, setMnuOrganismo] = useState(false);
 const [organismo, setOrganismo] = useState(false);

 const [mnuCasos, setMnuCasos] = useState(false);
 const [listarCasosPreJudicial, setListarCasosPreJudicial] = useState(false);
 const [listarCasosJudicial, setListarCasosJudicial] = useState(false);
 const [historialCasos, setHistorialCasos] = useState(false);
 const [listarCasosCualitativos, setListarCasosCualitativos] = useState(false);
 const [casoEtapa, setCasoEtapa] = useState(false);
 
 const [mnuConfiguracionesPreJudicial, setMnuConfiguracionesPreJudicial] = useState(false);
 const [casoEstado, setCasoEstado] = useState(false);
 const [casoEventoTipo, setCasoEventoTipo] = useState(false);
 
 const [mnuConfiguracionesJudicial, setMnuConfiguracionesJudicial] = useState(false);
 const [casoEstadoJudicial, setCasoEstadoJudicial] = useState(false);
 const [casoEventoTipoJudicial, setCasoEventoTipoJudicial] = useState(false);
 const [judEventoRestriccion, setJudEventoRestriccion] = useState(false);
 const [mnuConfiguracionesCualitativo, setMnuConfiguracionesCualitativo] = useState(false);
 const [casoCualitativoEstado, setCasoCualitativoEstado] = useState(false);
 const [casoCualitativoEventoTipo, setCasoCualitativoEventoTipo] = useState(false);

  const [idperfil, setidPerfil] = useState(false);
  const [perfiles, setPerfiles] = useState(false);
  const [usuarios, setUsuarios] = useState(false);
  const [mnuseguridad, setMnuSeguridad] = useState(false);
  const [roles, setRol] = useState(false);
  const [nombreboton, setnombreboton] = useState("Cancelar");
  const [progress, setProgress] = useState(0);
  const [showprogrees, setShowprogrees] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [exito, setExito] = useState(false);
  const listaPerfilPermisoRef = useRef([]);
  const [grabando, setGrabando] = useState(false);
  useEffect(() => {
    setidPerfil(id);
    // Aquí realizas la llamada a tu API para obtener el Departamento específico por su ID
    const GetPermisos = async () => {
      try {
        
        const response = await await getData(`/PerfilxPermiso/${id}`);
        const data = response.value;

        const SUJETO = data.some(
          (item) => item.codigoPermiso === itemsMenu.SUJETO.valor
        );

        setMnuSujeto(SUJETO);
        const SUJETOS = data.some(
          (item) => item.codigoPermiso === itemsMenu.SUJETO.valor
        );
        setSujeto(SUJETOS);
        const IMPORTARARCHIVO = data.some(
          (item) => item.codigoPermiso === itemsMenu.IMPORTARARCHIVO.valor
        );
        setImportarArchivo(IMPORTARARCHIVO);
        const TIPOCONTACTO = data.some(
          (item) => item.codigoPermiso === itemsMenu.TIPOCONTACTO.valor
        );

        setTipoContacto(TIPOCONTACTO);
        const TIPOIDENTIFICACION = data.some(
          (item) => item.codigoPermiso === itemsMenu.TIPOIDENTIFICACION.valor
        );

        setTipoIdentificacion(TIPOIDENTIFICACION);
        const ORIGEN = data.some(
          (item) => item.codigoPermiso === itemsMenu.ORIGENES.valor
        );
        setOrigen(ORIGEN);
        const PRIORIDADCONTACTO = data.some(
          (item) => item.codigoPermiso === itemsMenu.PRIORIDADCONTACTO.valor
        );
        setPrioridadContacto(PRIORIDADCONTACTO);
        setMensajes(data.some((item) => item.codigoPermiso === itemsMenu.MENSAJES.valor));
        setMotivoCualitativo(data.some((item) => item.codigoPermiso === itemsMenu.MOTIVOCUALITATIVO.valor));
        const ORGANISMO = data.some(
          (item) => item.codigoPermiso === itemsMenu.ORGANISMO.valor
        );
        setMnuOrganismo(ORGANISMO);
        const ORGANISMOS = data.some(
          (item) => item.codigoPermiso === itemsMenu.ORGANISMOS.valor
        );
        setOrganismo(ORGANISMOS);
        const MNUCASOS = data.some(
          (item) => item.codigoPermiso === itemsMenu.CASOS.valor
        );
        setMnuCasos(MNUCASOS);
        const LISTARCASOSPREJUDICIAL = data.some(
          (item) => item.codigoPermiso === itemsMenu.LISTARCASOSPREJUDICIAL.valor
        );
        setListarCasosPreJudicial(LISTARCASOSPREJUDICIAL);
        const LISTARCASOSJUDICIAL = data.some(
          (item) => item.codigoPermiso === itemsMenu.LISTARCASOSJUDICIAL.valor
        );
        setListarCasosJudicial(LISTARCASOSJUDICIAL);
        const HISTORIALCASOS = data.some(
          (item) => item.codigoPermiso === itemsMenu.HISTORIALCASOS.valor
        );
        setHistorialCasos(HISTORIALCASOS);
        setListarCasosCualitativos(data.some((item) => item.codigoPermiso === itemsMenu.LISTARCASOSCUALITATIVOS.valor));
        const CASOETAPA = data.some(
          (item) => item.codigoPermiso === itemsMenu.CASOETAPA.valor
        );
        setCasoEtapa(CASOETAPA);
        
        const MNUCONFIGURACIONESPREJUDICIAL = data.some(
          (item) => item.codigoPermiso === itemsMenu.CONFIGURACIONES_PREJUDICIALES.valor
        );
        setMnuConfiguracionesPreJudicial(MNUCONFIGURACIONESPREJUDICIAL);
        const CASOESTADO = data.some(
          (item) => item.codigoPermiso === itemsMenu.CASOESTADO.valor
        );
        setCasoEstado(CASOESTADO);
        const CASOEVENTOTIPO = data.some(
          (item) => item.codigoPermiso === itemsMenu.CASOEVENTOTIPO.valor
        );
        setCasoEventoTipo(CASOEVENTOTIPO);
        
        const MNUCONFIGURACIONESJUDICIAL = data.some(
          (item) => item.codigoPermiso === itemsMenu.CONFIGURACIONES_JUDICIALES.valor
        );
        setMnuConfiguracionesJudicial(MNUCONFIGURACIONESJUDICIAL);
        const CASOESTADOJUDICIAL = data.some(
          (item) => item.codigoPermiso === itemsMenu.CASOESTADOJUDICIAL.valor
        );
        setCasoEstadoJudicial(CASOESTADOJUDICIAL);
        const CASOEVENTOTIPOJUDICIAL = data.some(
          (item) => item.codigoPermiso === itemsMenu.CASOEVENTOTIPOJUDICIAL.valor
        );
        setCasoEventoTipoJudicial(CASOEVENTOTIPOJUDICIAL);
        setJudEventoRestriccion(data.some((item) => item.codigoPermiso === itemsMenu.JUDEVENTORESTRICCION.valor));
        setMnuConfiguracionesCualitativo(data.some((item) => item.codigoPermiso === itemsMenu.CONFIGURACIONES_CASOS_CUALITATIVOS.valor));
        setCasoCualitativoEstado(data.some((item) => item.codigoPermiso === itemsMenu.CASOCUALITATIVOESTADO.valor));
        setCasoCualitativoEventoTipo(data.some((item) => item.codigoPermiso === itemsMenu.CASOCUALITATIVOEVENTOTIPO.valor));
        const SEGURIDAD = data.some(
          (item) => item.codigoPermiso === itemsMenu.SEGURIDAD.valor
        );
        setMnuSeguridad(SEGURIDAD);
        const USUARIOS = data.some(
          (item) => item.codigoPermiso === itemsMenu.USUARIOS.valor
        );
        setUsuarios(USUARIOS);
        const PERFILES = data.some(
          (item) => item.codigoPermiso === itemsMenu.PERFILES.valor
        );
        setPerfiles(PERFILES);
       
        const AUDITORIA = data.some(
          (item) => item.codigoPermiso === itemsMenu.AUDITORIA.valor
        );
        setMnuAuditoria(AUDITORIA);

        const MODULOBI = data.some(
          (item) => item.codigoPermiso === itemsMenu.MODULOBI.valor
        );
        setModuloBI(MODULOBI);

      } catch (error) {
        console.error("Error:", error);
      }
    };
    GetPermisos();
  }, [id]);

  // Función para agregar un nuevo item a la lista
  const agregarItem = (codigoPermiso) => {
    const nuevoItem = {
      IDPerfil: idperfil,
      codigoPermiso: codigoPermiso.valor,
    }; // Ejemplo de nuevo item
    listaPerfilPermisoRef.current.push(nuevoItem);
  };

  const handleSubmit = async (data) => {
    try {
      setLoading(true);
      
      listaPerfilPermisoRef.current = [];
      
      if (mnusujeto ||  sujeto || importarArchivo) {
        agregarItem(itemsMenu.SUJETO);
      }
      if (sujeto === true) {
        agregarItem(itemsMenu.SUJETOS);
      }
      if (importarArchivo === true) {
        agregarItem(itemsMenu.IMPORTARARCHIVO);
      }
      if (mnuOrganismo || organismo || tipoContacto || origen || tipoIdentificacion || prioridadContacto || mensajes || motivoCualitativo || casoEtapa) {
        agregarItem(itemsMenu.ORGANISMO);
      }
      if (organismo === true) {
        agregarItem(itemsMenu.ORGANISMOS);
      }
      if (tipoContacto === true) {
        agregarItem(itemsMenu.TIPOCONTACTO);
      }
      if (tipoIdentificacion === true) {
        agregarItem(itemsMenu.TIPOIDENTIFICACION);
      }
      if (origen === true) {
        agregarItem(itemsMenu.ORIGENES);
      }
      if (prioridadContacto === true) {
        agregarItem(itemsMenu.PRIORIDADCONTACTO);
      }
      if (mensajes === true) {
        agregarItem(itemsMenu.MENSAJES);
      }
      if (motivoCualitativo === true) {
        agregarItem(itemsMenu.MOTIVOCUALITATIVO);
      }
      if (casoEtapa === true) {
        agregarItem(itemsMenu.CASOETAPA);
      }
      
      if (mnuConfiguracionesPreJudicial || casoEstado || casoEventoTipo) {
        agregarItem(itemsMenu.CONFIGURACIONES_PREJUDICIALES);
      }
      if (casoEstado === true) {
        agregarItem(itemsMenu.CASOESTADO);
      }
      if (casoEventoTipo === true) {
        agregarItem(itemsMenu.CASOEVENTOTIPO);
      }
      
      if (mnuConfiguracionesJudicial || casoEstadoJudicial || casoEventoTipoJudicial || judEventoRestriccion) {
        agregarItem(itemsMenu.CONFIGURACIONES_JUDICIALES);
      }
      if (casoEstadoJudicial === true) {
        agregarItem(itemsMenu.CASOESTADOJUDICIAL);
      }
      if (casoEventoTipoJudicial === true) {
        agregarItem(itemsMenu.CASOEVENTOTIPOJUDICIAL);
      }
      if (judEventoRestriccion === true) {
        agregarItem(itemsMenu.JUDEVENTORESTRICCION);
      }
      if (mnuConfiguracionesCualitativo || casoCualitativoEstado || casoCualitativoEventoTipo) {
        agregarItem(itemsMenu.CONFIGURACIONES_CASOS_CUALITATIVOS);
      }
      if (casoCualitativoEstado === true) {
        agregarItem(itemsMenu.CASOCUALITATIVOESTADO);
      }
      if (casoCualitativoEventoTipo === true) {
        agregarItem(itemsMenu.CASOCUALITATIVOEVENTOTIPO);
      }
      
      if (mnuCasos || listarCasosPreJudicial || listarCasosJudicial || listarCasosCualitativos || historialCasos) {
        agregarItem(itemsMenu.CASOS);
      }
      if (listarCasosPreJudicial === true) {
        agregarItem(itemsMenu.LISTARCASOSPREJUDICIAL);
      }
      if (listarCasosJudicial === true) {
        agregarItem(itemsMenu.LISTARCASOSJUDICIAL);
      }
      if (listarCasosCualitativos === true) {
        agregarItem(itemsMenu.LISTARCASOSCUALITATIVOS);
      }
      if (historialCasos === true) {
        agregarItem(itemsMenu.HISTORIALCASOS);
      }
      
      if (mnuseguridad || usuarios || perfiles || roles) {
        agregarItem(itemsMenu.SEGURIDAD);
      }
      if (usuarios === true) {
        agregarItem(itemsMenu.USUARIOS);
      }
      if (perfiles === true) {
        agregarItem(itemsMenu.PERFILES);
      }
      if (moduloBI === true) {
        agregarItem(itemsMenu.MODULOBI);
        agregarItem(itemsMenu.AUDITORIA);
      }

      const payload = {
        idPerfil: parseInt(idperfil),
        listOfPermisos: listaPerfilPermisoRef.current
      };

      const response = await postData("/PerfilxPermisoDTOModificacion", payload);

      const res = await response;

      if (res.isSuccess) {
        // Manejar respuesta exitosa
        setMensaje("Los Permisos han sido Registrado exitosamente!");
        setGrabando(true);
        setExito(true);
        setnombreboton("Volver");
      } else {
        // Manejar errores si la respuesta no es exitosa
        setMensaje(res.error);
        setExito(false);
        setGrabando(false);
      }
    } catch (error) {
      setMensaje("Error en la solicitud:", error);
      setGrabando(true); 
      setnombreboton("Cancelar");
    } finally {
      setLoading(false);
      setShowprogrees(0);
      setProgress(100);
    }
  };
 
  const HandleMnuSeguridad = (event) => {
    setMnuSeguridad(event.target.checked);
    setUsuarios(event.target.checked);
    setPerfiles(event.target.checked);
    setRol(event.target.checked);
  };
  
  const HandleMnuAuditoria = (event) => {
    setMnuAuditoria(event.target.checked);
    setModuloBI(event.target.checked);
  };

    const HandleMnuSujetos = (event) => {
      setMnuSujeto(event.target.checked);
      setSujeto(event.target.checked);
      setImportarArchivo(event.target.checked);
    };

  const HandleMnuCasos = (event) => {
    setMnuCasos(event.target.checked);
    setListarCasosPreJudicial(event.target.checked);
    setListarCasosJudicial(event.target.checked);
    setListarCasosCualitativos(event.target.checked);
    setHistorialCasos(event.target.checked);
  };
  
  const HandleMnuConfiguracionesPreJudicial = (event) => {
    setMnuConfiguracionesPreJudicial(event.target.checked);
    setCasoEstado(event.target.checked);
    setCasoEventoTipo(event.target.checked);
  };
  
  const HandleMnuConfiguracionesCualitativo = (event) => {
    setMnuConfiguracionesCualitativo(event.target.checked);
    setCasoCualitativoEstado(event.target.checked);
    setCasoCualitativoEventoTipo(event.target.checked);
  };

  const HandleMnuConfiguracionesJudicial = (event) => {
    setMnuConfiguracionesJudicial(event.target.checked);
    setCasoEstadoJudicial(event.target.checked);
    setCasoEventoTipoJudicial(event.target.checked);
    setJudEventoRestriccion(event.target.checked);
  };

  const HandleMnuOrganismos = (event) => {
    setMnuOrganismo(event.target.checked);
    setOrganismo(event.target.checked);
    setTipoContacto(event.target.checked);
    setOrigen(event.target.checked);
    setTipoIdentificacion(event.target.checked);
    setPrioridadContacto(event.target.checked);
    setMensajes(event.target.checked);
    setMotivoCualitativo(event.target.checked);
    setCasoEtapa(event.target.checked);
  };
  const handleVolver = () => {
    navigate("/PerfilesVolver"); // Cambia '/ruta-de-listado' por la ruta real de tu listado de datos
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="warning"
          borderRadius="lg"
          coloredShadow="warning"
          mx={2}
          mt={2}
          p={1}
          mb={1}
          textAlign="center"
          sx={{ position: "relative" }}
        >
          <MDBox sx={{ position: "absolute", top: 8, right: 8 }}>
            <ManualAyuda seccion="Perfiles y Permisos" />
          </MDBox>
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Permisos
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Esta seccion permite establecer que pantallas podra visualizar el
            usuario
          </MDTypography>
        </MDBox>
        
        <MDBox pt={1} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox>
                <Checkbox
                  name="mnuCasos"
                  onChange={(e) => HandleMnuCasos(e)}
                  checked={mnuCasos || listarCasosPreJudicial || listarCasosJudicial || listarCasosCualitativos || historialCasos }
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Gestion de Casos
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="listarCasosPreJudicial"
                  onChange={(e) => setListarCasosPreJudicial(e.target.checked)}
                  checked={listarCasosPreJudicial}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Gestion Pre-Judicial
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="listarCasosJudicial"
                  onChange={(e) => setListarCasosJudicial(e.target.checked)}
                  checked={listarCasosJudicial}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Gestion Judicial
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="listarCasosCualitativos"
                  onChange={(e) => setListarCasosCualitativos(e.target.checked)}
                  checked={listarCasosCualitativos}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Gestion de Casos Cualitativos
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="historialCasos"
                  onChange={(e) => setHistorialCasos(e.target.checked)}
                  checked={historialCasos}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Historial de Casos
                </MDTypography>
              </MDBox>
            <MDBox>
              <Checkbox
                name="mnusujeto"
                onChange={(e) => HandleMnuSujetos(e)}
                checked={mnusujeto || sujeto || importarArchivo}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Sujetos
              </MDTypography>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="sujeto"
                  onChange={(e) => setSujeto(e.target.checked)}
                  checked={sujeto}
                />

                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Sujeto
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="importarArchivo"
                  onChange={(e) => setImportarArchivo(e.target.checked)}
                  checked={importarArchivo}
                />

                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Importar Archivo
                </MDTypography>
              </MDBox>
              
              

              <MDBox>
                <Checkbox
                  name="mnuOrganismo"
                  onChange={(e) => HandleMnuOrganismos(e)}
                  checked={mnuOrganismo || organismo || tipoContacto || origen || tipoIdentificacion || prioridadContacto || mensajes || motivoCualitativo || casoEtapa }
                />
                <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Configuraciones
              </MDTypography>
              </MDBox>
              
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="organismo"
                  onChange={(e) => setOrganismo(e.target.checked)}
                  checked={organismo}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Organismo
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="tipoIdentificacion"
                  onChange={(e) => setTipoIdentificacion(e.target.checked)}
                  checked={tipoIdentificacion}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Tipo de Identificacion
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="tipoContacto"
                  onChange={(e) => setTipoContacto(e.target.checked)}
                  checked={tipoContacto}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Tipo de Contacto
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="origen"
                  onChange={(e) => setOrigen(e.target.checked)}
                  checked={origen}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Origenes de Contacto
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="prioridadContacto"
                  onChange={(e) => setPrioridadContacto(e.target.checked)}
                  checked={prioridadContacto}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Prioridades de Contacto
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="mensajes"
                  onChange={(e) => setMensajes(e.target.checked)}
                  checked={mensajes}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Mensajes
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="motivoCualitativo"
                  onChange={(e) => setMotivoCualitativo(e.target.checked)}
                  checked={motivoCualitativo}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Motivos de Campaña Cualitativa
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="casoEtapa"
                  onChange={(e) => setCasoEtapa(e.target.checked)}
                  checked={casoEtapa}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Instancias del Caso
                </MDTypography>
              </MDBox>
              
              <MDBox>
                <Checkbox
                  name="mnuConfiguracionesPreJudicial"
                  onChange={(e) => HandleMnuConfiguracionesPreJudicial(e)}
                  checked={mnuConfiguracionesPreJudicial || casoEstado || casoEventoTipo}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Configuraciones Pre-Judicial
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="casoEstado"
                  onChange={(e) => setCasoEstado(e.target.checked)}
                  checked={casoEstado}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Estados de la Gestion
                </MDTypography>
              </MDBox>

              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="casoEventoTipo"
                  onChange={(e) => setCasoEventoTipo(e.target.checked)}
                  checked={casoEventoTipo}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Tipos de Evento
                </MDTypography>
              </MDBox>
              
              <MDBox>
                <Checkbox
                  name="mnuConfiguracionesJudicial"
                  onChange={(e) => HandleMnuConfiguracionesJudicial(e)}
                  checked={mnuConfiguracionesJudicial || casoEstadoJudicial || casoEventoTipoJudicial || judEventoRestriccion}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Configuraciones Judicial
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="casoEstadoJudicial"
                  onChange={(e) => setCasoEstadoJudicial(e.target.checked)}
                  checked={casoEstadoJudicial}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Estados Judiciales
                </MDTypography>
              </MDBox>

              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="casoEventoTipoJudicial"
                  onChange={(e) => setCasoEventoTipoJudicial(e.target.checked)}
                  checked={casoEventoTipoJudicial}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Tipos de Evento Judicial
                </MDTypography>
              </MDBox>

              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="judEventoRestriccion"
                  onChange={(e) => setJudEventoRestriccion(e.target.checked)}
                  checked={judEventoRestriccion}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Restricciones de Eventos
                </MDTypography>
              </MDBox>

              <MDBox>
                <Checkbox
                  name="mnuConfiguracionesCualitativo"
                  onChange={(e) => HandleMnuConfiguracionesCualitativo(e)}
                  checked={mnuConfiguracionesCualitativo || casoCualitativoEstado || casoCualitativoEventoTipo}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Configuraciones Casos Cualitativos
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="casoCualitativoEstado"
                  onChange={(e) => setCasoCualitativoEstado(e.target.checked)}
                  checked={casoCualitativoEstado}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Estados de la Gestion (Cualitativos)
                </MDTypography>
              </MDBox>
              <MDBox sx={{ ml: 5 }}>
                <Checkbox
                  name="casoCualitativoEventoTipo"
                  onChange={(e) => setCasoCualitativoEventoTipo(e.target.checked)}
                  checked={casoCualitativoEventoTipo}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Tipos de Evento (Cualitativos)
                </MDTypography>
              </MDBox>
              
              <MDBox>
                <Checkbox
                  name="mnuseguridad"
                  onChange={(e) => HandleMnuAuditoria(e)}
                checked={ mnuauditoria|| moduloBI}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Auditoria
              </MDTypography>
            </MDBox>
             </MDBox>
            <MDBox sx={{ ml: 5 }}>
              <Checkbox
                name="moduloBI"
                onChange={(e) => setModuloBI(e.target.checked)}
                checked={moduloBI}
              />

              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Analisis e Informes
              </MDTypography>
            </MDBox>

            <MDBox>
              <Checkbox
                name="mnuseguridad"
                onChange={(e) => HandleMnuSeguridad(e)}
                checked={mnuseguridad || usuarios || perfiles || roles}
              />

              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Seguridad
              </MDTypography>
            </MDBox>
            <MDBox sx={{ ml: 5 }}>
              <Checkbox
                name="usuarios"
                onChange={(e) => setUsuarios(e.target.checked)}
                checked={usuarios}
              />

              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Usuarios
              </MDTypography>
            </MDBox>
            <MDBox sx={{ ml: 5 }}>
              <Checkbox
                name="perfiles"
                onChange={(e) => setPerfiles(e.target.checked)}
                checked={perfiles}
              />

              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Perfiles
              </MDTypography>
            </MDBox>
            
            <MDBox mb={1} style={{ display: "flex", gap: "16px" }}>
              <MDButton
                onClick={() => {
                  handleSubmit();
                }}
                variant="gradient"
                color="warning"
                endIcon={<Save2Fill />}
                disabled={grabando}
                fullWidth
              >
                Grabar
              </MDButton>

              <MDButton
                onClick={() => {
                  handleVolver();
                }}
                variant="gradient"
                color="warning"
                endIcon={<ExitToApp />}
                fullWidth
              >
                {nombreboton}
              </MDButton>
            </MDBox>
          </MDBox>
          <MDBox mt={1} mb={1}>
            <MDProgress
              color="success"
              loading="true"
              label={true}
              value={showprogrees === 0 ? progress : 0}
              display={loading && exito ? "true" : "false"}
              variant="contained"
            ></MDProgress>
          </MDBox>

          {mensaje !== "" && (
            <Alert severity={exito ? "success" : "error"}>
              <AlertTitle>{exito ? "Felicitaciones" : "Error"}</AlertTitle>
              {mensaje}
            </Alert>
          )}
        </MDBox>
      </Card>
    </BasicLayout>
  );
};

export default Permisos;
